<template>
  <v-container fluid class="bg-primary " >
    <v-row class="px-4 py-6" justify="space-between" align="start">
      <!-- First column: Company Information -->
      <v-col cols="12" sm="6" md="4" lg="4">
        <div class="footer-column">
          <div class="d-flex align-items-center">
            <v-img :src="logo" max-width="40" alt="Mero Prints  Logo" class="footer-logo me-3" lazy-src />

            <!-- <v-img :src="logo" max-width="40" alt="Mero Prints Logo" class="footer-logo me-3"></v-img> -->
            <h4 class="footer-title">Mero Prints</h4>
          </div>
          <p class="footer-paragraph">
            Mero Print specializes in high-quality ID cards and lanyards for
            schools, colleges, and offices. We provide easy online and offline
            ordering with fast delivery across Nepal. Our passion for printing
            ensures every order is handled with care and precision. Get your
            custom ID cards and lanyards today and experience reliable service
            and top-notch quality!
          </p>
          <div class="social-media-icons">
            <a href="https://www.facebook.com/brosoftpvtltd" target="_blank">
              <v-btn icon class="social-btn me-2">
                <v-icon color="blue">mdi-facebook</v-icon>
              </v-btn>
            </a>
            <a href="https://wa.me/9845468646" target="_blank">
              <v-btn icon class="social-btn me-2">
                <v-icon color="green">mdi-whatsapp</v-icon>
              </v-btn>
            </a>
            <a href="https://www.tiktok.com/@mero_prints?lang=en" target="_blank">
              <v-btn icon class="social-btn me-2">
                <img src="@/assets/icons/tiktok.svg" alt="TikTok" class="custom-icon" />
              </v-btn>
            </a>
            <a href="https://www.instagram.com/meroprintexpress/" target="_blank">
              <v-btn icon class="social-btn me-2">
                <v-icon color="purple">mdi-instagram</v-icon>
              </v-btn>
            </a>
          </div>
        </div>
      </v-col>

      <!-- Second column: Services -->
      <v-col cols="12" sm="6" md="4" lg="4">
        <!-- <v-col  class="scroll-item mb-7"cols="12" sm="6" md="4" lg="4"> -->
        <div class="footer-center-column">
          <h4 class="footer-title  md:text-left">Service</h4>
          <ul  v-if="serviceCards.length" class="footer-list grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-2">
            <li class="service-item" v-for="(item, index) in serviceCards" :key="index">
  <RouterLink :to="{ name: 'serviceProduct', params: { id: item.id } }" class="text-white">
    {{ item.title }}
  </RouterLink>
</li>
</ul>
<p v-else class="text-white">No services found at the moment.</p>

            <!-- <li class="service-item">
              <router-link to="/loyalty-card">Loyalty/Membership Card</router-link>
            </li>
            <li class="service-item">
              <router-link to="/digital-lanyard">Digital Lanyard</router-link>
            </li>
            <li class="service-item">
              <router-link to="/digital-belt">Digital Belt</router-link>
            </li>
            <li class="service-item">
              <router-link to="/photoshoot">Photoshoot</router-link>
            </li>
            <li class="service-item">
              <router-link to="/accessories">Accessories</router-link>
            </li>
            <li class="service-item">
              <router-link to="/attendance-system">Attendance System</router-link>
            </li>
            <li class="service-item">
              <router-link to="/id-card-system">ID Card System</router-link>
            </li>
            <li class="service-item">
              <router-link to="/school-software">School Software</router-link>
            </li> -->
          <!-- </ul> -->
        </div>
      </v-col>

      <!-- Third column: Support -->
      <v-col cols="12" sm="12" md="4" lg="4">
        <div>
          <h4 class="footer-title">Support</h4>
          <p class="footer-paragraph">
            Require assistance or have a specific inquiry? Our team is ready to
            assist you!
          </p>
          <p class="footer-contact">
            056-503147, <span class="ml-2">+977-9845468646</span>
          </p>
          <p class="footer-paragraph">Sunday - Friday (9:00 AM - 6:00 PM)</p>
        </div>
      </v-col>
    </v-row>

    <!-- Footer Bottom Section -->
    <p class="footer-bottom">
      Mero Prints {{ currentYear }} All Rights Reserved. A Venture Of
      <a href="https://www.brosoftltd.com/" class="footer-link" target="_blank">
        Bro Soft Pvt. Ltd.
      </a>
      <router-link class="footer-link" to="/terms-and-conditions">Terms & Conditions</router-link>
      <router-link class="footer-link" to="/privacy-policy">Privacy Policy</router-link>
    </p>
  </v-container>
</template>


<script setup>
import { useRouter,useRoute } from 'vue-router';
import { onMounted, watch, ref } from 'vue';
import { serviceCard } from '@/services/apiServices.js'

import logo from "@/assets/images/logos/LOGO-1.png";

const currentYear = ref(new Date().getFullYear());

const route = useRoute();
const error = ref("");
const serviceCards = ref([]);

watch(() => route.params.id, (newId) => {
  // productId.value = newId;
  fetchServicesCard(); // Re-fetch when ID changes
})
const fetchServicesCard = async () => {
  try {
    const data = await serviceCard();
    serviceCards.value = data;
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load classes";
    console.error("Error fetching class details:", err);
  }
};


onMounted(() => {
  fetchServicesCard(); // Initial fetch
});

</script>
<style scoped>
/* Footer Styles */
.footer-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.footer-column {
  padding-bottom: 16px;
}

.footer-title {
  font-family: "Inria Serif", serif;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 1.5;
  margin-bottom: 10px;
  color: #fff;
}

.footer-paragraph {
  font-size: 1rem;
  margin-bottom: 10px;
  color: #ddd;
}

.footer-list {
  padding: 0;
  list-style: none;
}

.footer-list li {
  margin-bottom: 8px;
}

.footer-list li a {
  color: #eee;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.footer-list li a:hover {
  color: #18e968;
}

.footer-contact {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 5px;
  color: #fff;
}

/* Social Media Icons */
.social-media-icons {
  display: flex;
  gap: 8px;
}

.social-media-icons a {
  text-decoration: none; /* Remove underline from anchor tag */
}

.social-media-icons a:hover {
  text-decoration: none; /* Remove underline on hover as well */
}

.social-btn {
  width: 40px;
  height: 40px;
  border: 2px solid #ddd;
  border-radius: 50%;
  background-color: #fff;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-btn:hover {
  background-color: #f5f5f5;
}

.v-icon {
  font-size: 20px;
}

.custom-icon {
  width: 20px;
  height: 20px;
}

.footer-bottom {
  text-align: center;
  font-size: 0.85rem;
  color: #ddd;
  margin-top: 16px;
}

.footer-link {
  color: #fff;
  text-decoration: none;
  margin-left: 8px;
  transition: text-decoration 0.3s ease;
}

.footer-link:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 600px) {
  .footer-title {
    font-size: 1.5rem;
  }

  .footer-paragraph {
    font-size: 0.9rem;
  }

  .footer-contact {
    font-size: 0.9rem;
  }

  .footer-center-column {
    /* margin: 0 16px; */
  }
}

@media (min-width: 601px) {
  .footer-center-column {
    margin: 0 40px;
  }
}

@media (min-width: 1200px) {
  .footer-center-column {
    margin: 0 80px;
  }
}

.service-item {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.service-item:hover {
  color: #fff;
  transform: translateX(5px);
}

.service-item a {
  color: #eee;
  text-decoration: none;
  font-weight: 500;
}

.service-item a:hover {
  color: #fff;
}
</style>
